// extracted by mini-css-extract-plugin
export default {"icon":"src-components-QuestionIconTooltip-css-module__icon--h7Io+"};